<div class="saved-searches">
  <label *ngFor="let saved of savedSearches"
    (mouseenter)="toggleShowDelete($event, true)" (mouseleave)="toggleShowDelete($event, false)"
    [ngClass]=" {'selected': saved.userPreferenceId == selectedSavedSearch?.userPreferenceId}">
    <span (click)="onClickSavedSearch(saved)">
      {{saved.name}}
    </span>
    <i class="far fa-trash-alt" style="color: var(--clr-red)" (click)="onClickDeleteSaved(saved.userPreferenceId)">
    </i>
  </label>
</div>

<ng-template #saveDialog>
  <div mat-dialog-content class="dialog">
    <fieldset>
      <label class="label">
        {{'SavedSearches.Name' | translate}}
      </label>
      <input class="text-input" type="text" [(ngModel)]="selectedSavedSearch.name">
    </fieldset>

    <ng-container *ngIf="selectedSavedSearch.userPreferenceId; else newSearch">
      <label class="label">
        {{'SavedSearches.SaveAsQuestion' | translate}}
      </label>
      <div class="buttons-container">
        <button class="button-basic" (click)="onSaveNewSearch()">
          {{'SavedSearches.SaveAsNew' | translate}}
        </button>
        <button class="button-basic" (click)="onUpdateExistingSearch()">
          {{'SavedSearches.OverwriteExisting' | translate}}
        </button>
      </div>
    </ng-container>

    <ng-template #newSearch>
      <div class="buttons-container">
        <button class="button-basic" (click)="onSaveNewSearch()">
          {{'SavedSearches.Save' | translate}}
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #deleteDialog let-userPreferenceId>
  <div mat-dialog-content class="dialog-delete">
    <label class="label">
      {{'SavedSearches.DeleteQuestion' | translate}}
    </label>

    <div class="buttons-container">
      <button class="button-basic" (click)="onDeleteSavedSearch(userPreferenceId)">
        {{'SavedSearches.Yes' | translate}}
      </button>
      <button class="button-basic" (click)="onCloseDeleteDialog()">
        {{'SavedSearches.Cancel' | translate}}
      </button>
    </div>
  </div>
</ng-template>
